<nz-affix [nzOffsetTop]="0" *transloco="let tr; prefix: 'deliveryZones'; scope: 'delivery-zones'">
  <nz-page-header [nzGhost]="false">
    <nz-page-header-title>{{tr('title')}}</nz-page-header-title>
    <nz-page-header-subtitle>{{tr('subTitle')}}</nz-page-header-subtitle>
    <nz-page-header-extra>
      <a routerLink="new" nz-button nzType="primary">
        <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{'button.addNew' | transloco}}
      </a>
    </nz-page-header-extra>
  </nz-page-header>
</nz-affix>


<nz-collapse nzBordered="false">
  <nz-collapse-panel [nzHeader]="'filters' | transloco" [nzActive]="true">
    <div nz-row [nzGutter]="[16,24]">
      <div nz-col>
        <hx-brand-select [(ngModel)]="filter.brandId" (ngModelChange)="applyFilters()"></hx-brand-select>
      </div>

      <div nz-col>
        <hx-city-select [(ngModel)]="filter.cityId" (ngModelChange)="applyFilters()"></hx-city-select>
      </div>

      <div nz-col>
        <small>&nbsp;</small>
        <nz-radio-group [(ngModel)]="filter.active" (ngModelChange)="applyFilters()" nzSize="small">
          <label nz-radio-button [nzValue]="false">Все</label>
          <label nz-radio-button [nzValue]="true">Активные</label>
        </nz-radio-group>
      </div>
    </div>
  </nz-collapse-panel>
</nz-collapse>

<nz-table [nzLoading]="isTableLoading" #listTable  *transloco="let tr; prefix: 'deliveryZones'; scope: 'delivery-zones'"
          [nzTotal]="total"
          [nzPageSize]="limit"
          [nzPageIndex]="page"
          [nzData]="list"
          (nzQueryParams)="onQueryParamsChange($event)"
          [nzFrontPagination]="false">
  <thead>
  <tr>
    <th>{{tr('column.brand')}}</th>
    <th>{{tr('column.city')}}</th>
    <th>{{tr('column.fromDate')}}</th>
    <th nzWidth="100px">#</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let data of list">
    <td>
      {{ data.brand.title }}
    </td>
    <td><strong>{{data.city.title | uiLabel}}</strong></td>
    <td>{{data.fromDate | date: 'dd.MM.yyyy'}}</td>
    <td>
      <nz-button-group>
        <a [routerLink]="data.id + '/edit'" nz-button nzType="primary">
          <i nz-icon nzType="edit" nzTheme="outline"></i>
        </a>
        <button nz-button nzType="default" nzDanger nz-popconfirm
                [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                [nzCancelText]="'no1' | transloco"
                (nzOnConfirm)="remove(data.id)">
          <i nz-icon nzType="delete" nzTheme="outline"></i>
        </button>
      </nz-button-group>
    </td>
  </tr>
  </tbody>
</nz-table>
